import { ROUTES } from 'constants/routes';
import { Routes, Route } from 'react-router-dom';
import Products from 'pages/Products';
import Resources from 'pages/Resources';
import MainLayout from 'Layout/main';
import AboutProducts from 'pages/AboutProduct';
import RelatedProduct from 'pages/RelatedProduct';
import CropNutritionPrograms from 'pages/CropNutritionPrograms';
import TrialResults from 'pages/TrialResults';
import DetailedOfCropNutrition from 'pages/DetailedOfCropNutrition';
import DetailedTrialResults from 'pages/DetailedTrialResults';
import InformationMaterials from 'pages/InformationMaterials';
import AboutUs from 'pages/AboutUs';
import News from 'pages/News';
import Research from 'pages/Research';
import Article from 'pages/Article';
import DetailedJob from 'pages/DetailedJob';
import Career from 'pages/Career';
import TermsAndConditions from 'pages/TermsAndConditions';
import LegalInfo from 'pages/LegalInfo';
import Contacts from 'pages/Contacts';
import Page404 from 'pages/Page404';
import { UIKit } from 'pages/UIKit/UIKit';
import { Homepage } from 'pages/Homepage/Homepage';

const App = () => (
    <>
        <Routes>
            <Route path="/ui-kit" element={<UIKit />} />
            <Route path={ROUTES.base} element={<MainLayout />}>
                <Route path={ROUTES.base} element={<Homepage />} />
                <Route path={ROUTES.products} element={<Products />} />
                <Route path={ROUTES.aboutProduct} element={<AboutProducts />} />
                <Route path={ROUTES.relatedProduct} element={<RelatedProduct />} />
                <Route path={ROUTES.resources} element={<Resources />} />
                <Route path={ROUTES.cropNutritionPrograms} element={<CropNutritionPrograms />} />
                <Route path={ROUTES.trialResults} element={<TrialResults />} />
                <Route path={ROUTES.detailCropNutritionPrograms} element={<DetailedOfCropNutrition />} />
                <Route path={ROUTES.detailTrialResults} element={<DetailedTrialResults />} />
                <Route path={ROUTES.informationMaterials} element={<InformationMaterials />} />
                <Route path={ROUTES.aboutUs} element={<AboutUs />} />
                <Route path={ROUTES.news} element={<News />} />
                <Route path={ROUTES.news + '/:slug'} element={<Article />} />
                <Route path={ROUTES.research} element={<Research />} />
                <Route path={ROUTES.article} element={<Article />} />
                <Route path={ROUTES.career} element={<Career />} />
                <Route path={ROUTES.career + '/:slug'} element={<DetailedJob />} />
                <Route path={ROUTES.termsAndConditions} element={<TermsAndConditions />} />
                <Route path={ROUTES.legalInfo} element={<LegalInfo />} />
                <Route path={ROUTES.contacts} element={<Contacts />} />
                <Route path="*" element={<Page404 />} />
            </Route>
        </Routes>
    </>
);

export default App;
